export default "__VITE_ASSET__BuaPOKqO__"